export class CostReviewIntegration {
  systemsThatRequireIntegration!: string;
  integrationProtocol!: number[];
  unitsFurnishedBy!: number;
  unitsInstalledBy!: number;
  unitsWiredBy!: number;
  graphicsRequired!: number;
  isIntegrationApplicatble!: boolean;
}
